export const UPDATE_TOOL_TYPE = 'UPDATE_TOOL_TYPE'